var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "qr-wrapper", style: _vm.containerStyle }, [
    _c("div", {
      staticClass: "qr-region",
      style: _vm.containerStyle,
      attrs: { id: _vm.regionId },
    }),
    _vm.loadingStart
      ? _c("div", { staticClass: "qr-overlay" }, [
          _c("div", { staticClass: "spinner" }),
          _c("div", { staticClass: "spinner-label" }, [
            _vm._v("Uruchamianie kamery…"),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }